import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import Pagination from '../pagination';
import { ColorAction } from '../../store/actions';

class List extends PureComponent {
  static propTypes = {
    authHasOffice: PropTypes.bool,
    colors: PropTypes.object,
    deleteColor: PropTypes.func,
    getColors: PropTypes.func,
    location: PropTypes.object,
  };

  componentDidMount() {
    this.props.getColors(
      Object.fromEntries(new URLSearchParams(this.props.location.search)),
    );
  }

  onDelete(row) {
    if (!confirm('Are you sure?')) {
      return;
    }
    this.props.deleteColor(row.id);
  }

  onSearch(event) {
    const {
      target: { value },
    } = event;
    this.props.getColors({ query: value });
  }

  render() {
    const {
      authHasOffice = false,
      colors: { data: colors = [], links = [] } = {},
      getColors = () => {},
      location = {},
      permissions = [],
    } = this.props;
    return (
      <div className="row">
        <div className="col">
          <div className="card">
            <div className="card-header">
              <h3 className="card-title">Color</h3>
              <div className="card-tools d-print-none">
                <Pagination
                  getList={getColors}
                  links={links}
                  location={location}
                />
              </div>
              <div className="card-tools d-print-none mr-2">
                <div
                  className="input-group input-group-sm"
                  style={{ width: '150px' }}
                >
                  <input
                    className="form-control"
                    onChange={this.onSearch.bind(this)}
                    placeholder="Search"
                    type="text"
                  />
                </div>
              </div>
              {permissions?.includes?.('color.create') && (
                <div className="card-tools d-print-none mr-2">
                  <div className="input-group input-group-sm">
                    <Link
                      className="btn btn-primary btn-sm"
                      to={`${this.props.match?.path}/create`}
                    >
                      <i className="fas fa-plus-square mr-1"></i>
                      Create
                    </Link>
                  </div>
                </div>
              )}
            </div>
            <div className="card-body p-0">
              {colors?.length === 0 && (
                <p className="text-center my-2">No data found.</p>
              )}
              {colors?.length > 0 && (
                <table className="table table-striped text-nowrap">
                  <thead>
                    <tr>
                      {permissions?.some?.(p =>
                        ['color.delete', 'color.edit']?.includes?.(p),
                      ) && (
                        <th
                          className="d-print-none"
                          style={{ minWidth: '175px' }}
                        >
                          Action
                        </th>
                      )}
                      {!authHasOffice && <th>Office</th>}
                      <th>Name</th>
                    </tr>
                  </thead>
                  <tbody>
                    {colors?.map?.(row => (
                      <tr key={row.id}>
                        {permissions?.some?.(p =>
                          ['color.delete', 'color.edit']?.includes?.(p),
                        ) && (
                          <td className="d-print-none">
                            <div className="btn-group">
                              {permissions?.includes?.('color.edit') && (
                                <Link
                                  className="btn btn-info btn-sm"
                                  to={`${this.props.match?.path}/${row.id}/edit`}
                                >
                                  <i className="fas fa-edit mr-1"></i>
                                  Edit
                                </Link>
                              )}
                              {permissions?.includes?.('color.delete') && (
                                <button
                                  className="btn btn-danger btn-sm"
                                  onClick={() => this.onDelete(row)}
                                  type="button"
                                >
                                  <i className="fas fa-trash mr-1"></i>
                                  Delete
                                </button>
                              )}
                            </div>
                          </td>
                        )}
                        {!authHasOffice && <td>{row.office?.name}</td>}
                        <td>{row.name}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  authHasOffice: !!state?.auth?.office,
  colors: state?.color?.list,
  permissions: state?.auth?.permissions,
});

const mapDispatchToProps = dispatch => ({
  deleteColor: id => dispatch(ColorAction.deleteColor(id)),
  getColors: params => dispatch(ColorAction.getColors(params)),
});

export default connect(mapStateToProps, mapDispatchToProps)(List);
